/* React */
import { useEffect, useState } from 'react'

/* Material */
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import useStyles from '../styles'

/* Types */
import { attribute } from 'src/shared/frontendTypes/product'
import { Status } from '../AddToCart'
import type { DisabledAttributeOptions } from '../../../functions/attributeAvailability'

export type selectedAttributes = Record<string, number | ''>

interface AttributesProps {
  attributes: attribute[]
  selectedAttributes: selectedAttributes
  handleChangeAttribute: (attribut: number, option: number | '') => void
  Status: Status
  disabledOptions?: DisabledAttributeOptions
}

const selectMenuProps = {
  disableScrollLock: true,
  PaperProps: {
    sx: {
      maxHeight: 'min(360px, calc(100vh - 96px))',
      mt: .5,
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
      WebkitOverflowScrolling: 'touch',
    },
  },
  MenuListProps: {
    sx: {
      py: .5,
    },
  },
} as const

const AttributesSelector: React.FC<AttributesProps> = ({
  attributes, selectedAttributes, handleChangeAttribute, Status, disabledOptions = {}
}) => {
  const classes = useStyles()
  const [openAttributeId, setOpenAttributeId] = useState<number | null>(null)

  useEffect(() => {
    if (openAttributeId === null || typeof window === 'undefined') return

    const { body, documentElement } = document
    const scrollY = window.scrollY
    const previousBodyStyles = {
      left: body.style.left,
      overflow: body.style.overflow,
      position: body.style.position,
      right: body.style.right,
      top: body.style.top,
      width: body.style.width,
    }
    const previousHtmlOverscroll = documentElement.style.overscrollBehavior

    body.style.left = '0'
    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.right = '0'
    body.style.top = `-${scrollY}px`
    body.style.width = '100%'
    documentElement.style.overscrollBehavior = 'none'

    return () => {
      body.style.left = previousBodyStyles.left
      body.style.overflow = previousBodyStyles.overflow
      body.style.position = previousBodyStyles.position
      body.style.right = previousBodyStyles.right
      body.style.top = previousBodyStyles.top
      body.style.width = previousBodyStyles.width
      documentElement.style.overscrollBehavior = previousHtmlOverscroll
      window.scrollTo(0, scrollY)
    }
  }, [openAttributeId])

  return <div>

    {attributes.map(attribute=>

      <div key={attribute.id}>

        <TextField
          id={`attribute-${attribute.id}`}
          className={classes.formControl}
          select variant='standard'
          label={attribute.name}
          value={selectedAttributes[attribute.id] ?? ''}
          //disabled={attribute.options.length===1}

          SelectProps={{
            MenuProps: selectMenuProps,
            onClose: () => setOpenAttributeId(current =>
              current === attribute.id ? null : current
            ),
            onOpen: () => setOpenAttributeId(attribute.id),
          }}

          //helperText="Wählen Sie bitte die Eigenschaft"

          onChange={({target:{value}}) => {
            const parsedValue = Number(value)
            handleChangeAttribute(
              attribute.id,
              Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : ''
            )
          }}

          error={
            Status==='tried' && selectedAttributes[attribute.id] === ''
          }
        >

          <MenuItem key='placeholder' value='' disabled>
            Bitte wählen
          </MenuItem>

          {attribute.options?.map(option=>
            <MenuItem
              key={option.id}
              value={option.id}
              disabled={disabledOptions[attribute.id]?.[option.id] === true}
            >
              {option.name}
            </MenuItem>
          )}

        </TextField>

      </div>

    )}

  </div>
  
}

export default AttributesSelector
